'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { SessionExpiryListener } from './SessionExpiryListener';
import { SessionTimeoutManager, type SessionTimeoutManagerProps } from './SessionTimeoutManager';
export type SessionManagementProps = SessionTimeoutManagerProps;

/**
 * Single mount point for client-side session robustness:
 * - {@link SessionExpiryListener}: auto sign-out on session-expiry 401s.
 * - {@link SessionTimeoutManager}: idle prompt + auto sign-out.
 *
 * Render once near the app root, inside the auth `SessionProvider`.
 */
export function SessionManagement(props) {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.redirectTo) {
    t0 = <SessionExpiryListener redirectTo={props.redirectTo} />;
    $[0] = props.redirectTo;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <SessionTimeoutManager {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}